<div class="no-fly-time-header" *ngIf="noFlyTimeActive && isKioskMode" (click)="openNoFlyTimeTooltip()">
	<img *ngIf="noFlyTimeActive" class="no-fly-time-icon" [src]="'./assets/no-fly-time (2).svg' | resolveAsset" />
	<span *ngIf="noFlyTimeActive">No Fly Time Until {{ currentNoFlyEndTimeString }}</span>
</div>

<sp-emergency-banner *ngIf="(isStaff$ | async) && emergencyActive && !isKioskMode"></sp-emergency-banner>
<mat-sidenav-container id="teacher-view" (backdropClick)="fadeClick()" [style.overflow]="!(isStaff$ | async) ? 'auto' : 'hidden'">
	<mat-sidenav class="settings-side-nav" mode="over" [fixedInViewport]="true" [opened]="toggleLeft | async">
		<ng-container *ngIf="screenService.isDeviceLargeExtra">
			<app-settings [dataSideNav]="data"></app-settings>
		</ng-container>
	</mat-sidenav>

	<mat-sidenav-content>
		<div class="sticky" [style.height]="navbarHeight">
			<app-navbar (settingsClick)="onSettingClick($event)"></app-navbar>
		</div>

		<ng-container *ngIf="!(restriction$ | async); else restriction">
			<router-outlet></router-outlet>
		</ng-container>
		<ng-template #restriction>
			<ng-container>
				<app-assistant-restriction></app-assistant-restriction>
			</ng-container>
		</ng-template>
	</mat-sidenav-content>
</mat-sidenav-container>
<app-offline-bar></app-offline-bar>
